import React, { useContext, useEffect, useMemo, useRef } from 'react'
import ReportContent from '@comp/tableDrawer/reportContent'
import ReportHeader from '@comp/tableDrawer/reportHeader'
import { GetAllProvider } from '@/api/endpoints'
import { useNavigate } from 'react-router-dom'
import BaseBtn from '@comp/tableDrawer/TableItems/components/tableActions/baseBtn'
import { DomainContext } from '@context/DomainContext'
import { PROVIDER_REQUEST_STATUS } from '@/data/status'
import ReportSearch from '@comp/tableDrawer/reportSearch'

const Rejected = ({ columns, TabsSection }) => {

    const openInsertModal = useRef()
    const { setCustomSearchData } = useContext(DomainContext)

    const navigate = useNavigate()


    const tableColumns = useMemo(() => [...columns
        ,
    {
        id: 'action',
        Cell: ({ row: { original } }) =>
            <BaseBtn action={"show-details"} onApply={() => navigate(`/panel/request-details/${original?.id}`)} icon={"solar:eye-outline"} className="details-info" reqAction="canAdd" />
    }
    ], [])


    useEffect(() => {
        setCustomSearchData(prev => ({ ...prev, statusId: PROVIDER_REQUEST_STATUS?.Rejected }))
    }, [])



    return (
        <ReportContent tableAPI={GetAllProvider} columns={tableColumns}>
            <ReportHeader ApplyAction={openInsertModal} >
                <ReportSearch />
            </ReportHeader>
            <TabsSection />
        </ReportContent>
    )
}

export default Rejected